module.exports = __webpack_public_path__ + "47d6b1861b38e4db42ff7e41014d84f8.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/icons/home_24.svg
// module id = 1325
// module chunks = 65